const Tables = {
  sizes: {
    xs: {
      th: { fontSize: "xs", py: 1, px: 2 },
      td: { fontSize: "xs", py: 1, px: 2 },
    },
    sm: {
      th: { fontSize: "sm", py: 2, px: 2 },
      td: { fontSize: "sm", py: 2, px: 2 },
    },
    md: {
      th: { fontSize: "md", py: 1.5, px: 3 },
      td: { fontSize: "md", py: 1.5, px: 3 },
    },
    lg: {
      th: { fontSize: "lg", py: 2, px: 3 },
      td: { fontSize: "lg", py: 2, px: 3 },
    },
    xl: {
      th: { fontSize: "xl", py: 2, px: 4 },
      td: { fontSize: "xl", py: 2, px: 4 },
    },
  },
  baseStyle: {
    table: {
      overflowY: "auto",
    },
    thead: {
      position: "sticky",
      boxShadow: "md",
      top: 0,
      borderColor: "Gray.300",
      borderRadius: "lg",
      bg: "white",
    },
    tbody: {
      bg: "white",
    },
    tr: {
      _hover: { bg: "Gray.200" },
    },
    td: {
      borderBottom: "1px solid",
      borderColor: "Gray.200",
    },
    th: {},
  },
  variants: {
    dataTable: {
      th: {
        boxShadow:
          "inset 0 1px 0 rgba(0, 0, 0, 0.1), inset -1px 0 0 rgba(0, 0, 0, 0.1)",
        fontWeight: 400,
      },
    },
  },
}

export default Tables
